export enum ReportTitleEnum {
  REVENUE = 'financialSummary.report.title.revenue',
  TOTAL_REVENUE = 'financialSummary.report.title.totalRevenue',
  EXPENSE = 'financialSummary.report.title.expense',
  TOTAL_EXPENSE = 'financialSummary.report.title.totalExpense',
  TOTAL_PROFIT = 'financialSummary.report.title.totalProfit',
}
